import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import graph from './graph';
import Error from './Error';
import Loading from './Loading';
import NotFound from './NotFound';
import Content from './Content';

export default function Controller({ id, refetch: refetchParent, onClose }) {
  const { userToken } = useSelector((state) => state.auth);

  const {
    data,
    error,
    loading,
    refetch: refresh,
  } = useQuery(graph.list.query, {
    context: {
      serviceName: graph.list.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
    variables: {
      ids: id,
      for_admin: 1,
    },
  });

  const refetch = () => refresh();

  if (loading) {
    return <Loading onClose={onClose} />;
  }

  if (error) {
    return <Error onClose={onClose} error={error?.message} refetch={refetch} />;
  }

  const res = data[graph.list.name]?.data;

  if (!res) {
    return <NotFound onClose={onClose} />;
  }

  return <Content onClose={onClose} res={res} refetch={refetch} />;
}
